import { Directive, Input, ElementRef, OnInit, Renderer } from '@angular/core';

@Directive({
    selector: '[tooltip]',
    exportAs: 'tooltip',

    host: {
        // '[style.background-color]': '"yellow"',
    }
})
export class TooltipDirective implements OnInit {

    /**
     *
     * @param element
     *
     */
    constructor(private renderer: Renderer, private element: ElementRef) { }

    //
    tooltipElement = document.createElement('div');
    visible: boolean = false;

    /**
     *
     */
    @Input()
    set tooltip(value) {
      // console.log('value is : ', value);
        this.tooltipElement.textContent = value;
    }

    @Input('hellokitty')
    hellokitty: string = "initial hello";


    ngOnInit(): void {

        // setTimeout(() => {
        //   console.log(this.hellokitty);
        // }, 1000);

        // this.tooltipElement.classList.add("tooltip");
        // this.tooltipElement.setAttribute('class', 'tooltip');

        //TODO:
        //class
        // this.tooltipElement.style.background = 'yellow';
        // background: rgba(0, 0, 0, 0.7);
        // color: #fff;
        // line-height: 1;
        // font-size: 14px;
        // padding: 5px 7px;
        // border-radius: 5px;
        // position: absolute;
        // top: 0;
        // left: 100%;
        // height: 100px;
        //

        this.tooltipElement.style.background = 'rgba(0, 0, 0, 0.7)';
        this.tooltipElement.style.color = '#fff';
        this.tooltipElement.style.lineHeight = '1';
        this.tooltipElement.style.padding = '5px 7px';
        // this.tooltipElement.style.position= ' absolute';
        this.tooltipElement.style.marginLeft = '20px';
        this.tooltipElement.style.borderRadius = '5px';
        this.tooltipElement.style.top = ' 0';
        this.tooltipElement.style.left = '100%';
        this.tooltipElement.style.height = 'auto';
        this.tooltipElement.style.whiteSpace = 'nowrap';
        this.tooltipElement.style.fontSize = '11px'
        this.tooltipElement.style.display = 'none';




        this.element.nativeElement.appendChild(this.tooltipElement);
        // this.element.nativeElement.classList.add('tooltip-container');
        this.renderer.setElementClass(this.element.nativeElement, 'tooltip-container', true);
        // console.log(this.tooltipElement, this.element);
    }


    /**
     *
     */

    hide() {
        this.tooltipElement.style.display = 'none';
    }

    show() {
        this.tooltipElement.style.display = 'block';
    }


}



// WEBPACK FOOTER //
// ./src/app/tooltip/tooltips.directive.ts